import { atom } from 'jotai/vanilla';
import { GraphQLClient } from 'graphql-request';

const client = atom(() => {
  const customFetch = (input: RequestInfo | URL, init?: RequestInit) => {
    return fetch(input, {
      ...init,
      credentials: 'include',
    });
  };
  return new GraphQLClient(process.env.VITE_API_HOST as string, {
    errorPolicy: 'all',
    fetch: customFetch,
  });
});

const is_loading = atom(false);

export default { client, is_loading };
